import React from 'react';
import PropTypes from 'prop-types';

const MobileMenuItem = props => <li>{props.children}</li>;

MobileMenuItem.propTypes = {
  children: PropTypes.node.isRequired
};

export default MobileMenuItem;
